import React, { useState, useRef, ReactNode, FC, useEffect } from "react";
import "./tooltip.scss";

interface TooltipProps {
  children: ReactNode;
  delay?: number;
  direction?: string;
  content: ReactNode;
  visible?: boolean;
  useFixedPositioning?: boolean;
}

const Tooltip: FC<TooltipProps> = (props) => {
  const timeoutRef = useRef<NodeJS.Timeout>();
  const [active, setActive] = useState<boolean>(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const showTip = () => {
    if (!(props.visible ?? true)) return;
    timeoutRef.current = setTimeout(() => {
      setActive(true);
      if (props.useFixedPositioning) {
        positionTooltip();
      }
    }, props.delay || 300);
  };

  const hideTip = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setActive(false);
  };

  const positionTooltip = () => {
    if (!active || !tooltipRef.current || !wrapperRef.current) return;
  
    const cellRect = wrapperRef.current.getBoundingClientRect();
    const tooltipRect = tooltipRef.current.getBoundingClientRect();
  
    let top = cellRect.top - tooltipRect.height * 0.4;
    let left = cellRect.left + cellRect.width * 0.1 + 10;
  
    const windowWidth = window.innerWidth;
  
    if (left + tooltipRect.width > windowWidth) {
      left = windowWidth - tooltipRect.width - 10;
    }
    if (top < 0) {
      top = cellRect.bottom + 10;
    }
  
    tooltipRef.current.style.top = `${top}px`;
    tooltipRef.current.style.left = `${left}px`;
    tooltipRef.current.style.position = 'fixed';
    tooltipRef.current.style.maxWidth = '300px';
  };
  

  useEffect(() => {
    if (active && props.useFixedPositioning) {
      positionTooltip();
    }
  }, [active, props.useFixedPositioning]);

  return (
    <div
      className="tooltip-wrapper"
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
      data-testid="tooltip-wrapper"
      ref={wrapperRef}
    >
      {props.children}
      {active && (props.visible ?? true) && (
        <div
          data-testid="tooltip-text"
          className={`tooltip-tip ${props.direction || "top"} ${
            props.content?.toString().length > 100
              ? "tooltip-max-content"
              : "tooltip-content"
          }`}
          ref={tooltipRef}
        >
          {props.content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;